<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('navMenu.personnel')" position="top" v-if="isRouterEmployee()">
                <feather-icon icon="UsersIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="editEmployee"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.edit')" position="top">
                <feather-icon icon="EditIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top" v-if="isPermissionDelete()">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>
    </div>
</template>

<script>
import {isAPI, isRouter} from "../../../../../store/permission";
import {constAPI, constRouter} from "../../../../../store/constant";

export default {
    name: 'CellRendererActions',
    methods: {
        isRouterEmployee(){
            return isRouter(this, constRouter.employee_all);
        },
        isPermissionDelete(){
            return isAPI(this, constAPI.organization_branch_delete);
        },
        isPermissionUpdate(){
            return isAPI(this, constAPI.organization_branch_edit);
        },
        editEmployee() {
            this.$router.push(`/user/manage-employee?branch_id=${this.params.data.id}`).catch(() => {
            })
        },
        editRecord() {
            this.$store.commit('BRANCH_UPDATE_INFO', this.params.data);
            this.$router.push(`/user/edit-organization-branch?id=${this.params.data.id}`).catch(() => {
            })
        },

        editCamera() {
            this.$router.push(`/user/manage-camera?branch_id=${this.params.data.id}`).catch(() => {
            })
        },

        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá chi nhánh "${this.params.data.organizationBranchName}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteRecord() {
            this.$vs.loading();
            this.$crm.post(`/organization-branch/delete/${this.params.data.id}`).then(() => {
                this.$vs.loading.close();
                return this.showDeleteSuccess();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$store.commit('DELETE_BRANCH_STATUS', true);
            this.$vs.notify({
                color: 'success',
                text: 'Xoá chi nhánh thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    }
}
</script>

<style scoped>


</style>
